import BusinessForm from '@/components/businesses/BusinessForm';
import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetBusinessDetails } from '@/hooks/requests/useBusinesses';
import { Card, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

export default function BusinessEditPage() {
  const navigate = useNavigate();
  const { uuid = '' } = useParams();
  const { businessDetails, isBusinessDetailsPending } =
    useGetBusinessDetails(uuid);

  if (isBusinessDetailsPending) {
    return (
      <DefaultLayout header="">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!businessDetails) {
    return (
      <DefaultLayout header="">
        <Card>
          <Typography>
            Something went wrong retreiving the customer. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header={`Edit ${businessDetails.legalBusinessName}`}
      breadcrumb={[
        { label: 'Businesses', href: ROUTES.BUSINESSES },
        {
          label: businessDetails.legalBusinessName,
          href: `${ROUTES.BUSINESSES}/${businessDetails.uuid}`,
        },
        { label: 'Edit', isActive: true },
      ]}>
      <BusinessForm
        isEdit
        defaultValues={{
          uuid,
          name: businessDetails.legalBusinessName,
          dbaName: businessDetails.dbaName,
          legalStructure: businessDetails.legalStructure.toString(),
          tin: businessDetails.tin,
          confirmTin: businessDetails.tin,
          company: businessDetails.company?.uuid || '',
          companyName: businessDetails.company?.name,
          advisors:
            businessDetails.advisors?.map(advisor => advisor.uuid) || [],
          currentAddress: {
            line1: businessDetails.currentAddress.line1,
            line2: businessDetails.currentAddress.line2,
            city: businessDetails.currentAddress.city,
            state: businessDetails.currentAddress.state,
            postalCode: businessDetails.currentAddress.postalCode,
          },
          sameMailingAddress: businessDetails.isMailingAddressSameCurrentAddr,
          mailingAddress: {
            line1: businessDetails.mailingAddress.line1,
            line2: businessDetails.mailingAddress.line2,
            city: businessDetails.mailingAddress.city,
            state: businessDetails.mailingAddress.state,
            postalCode: businessDetails.mailingAddress.postalCode,
          },
          // You can't change members when editing a business so we leave it blank
          members: [],
        }}
        onSuccess={(uuid: string) => navigate(`${ROUTES.BUSINESSES}/${uuid}`)}
      />
    </DefaultLayout>
  );
}
